import { render } from "./FrameTypes.vue?vue&type=template&id=22d0410b&scoped=true"
import script from "./FrameTypes.vue?vue&type=script&lang=js"
export * from "./FrameTypes.vue?vue&type=script&lang=js"

import "./FrameTypes.vue?vue&type=style&index=0&id=22d0410b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d0410b"]])

export default __exports__